export const language: any = {
  selected_ingredients: 'ส่วนผสมที่เลือก',
  recommend: 'จานที่แนะนำ',
  title_detail: 'สูตรอาหารที่แนะนำ',
  share: 'แชร์',
  ingredients: {
    title: `<span class="tracking-tighter whitespace-nowrap">ส่วนผสม</span> <span class="tracking-tighter whitespace-nowrap">(1 ที่)</span>`,
    add_all: 'เพิ่มส่วนผสมทั้งหมด',
    view_more: 'ดูส่วนผสมเพิ่มอีก {number} รายการ',
    view_less: 'พับ',
    delete_all: 'ลบส่วนผสมทั้งหมด',
  },
  how_to_cook: 'วิธีการทำอาหาร',
  video: {
    title: 'สูตรอาหารในรูปแบบวิดีโอ',
  },
  msg: {
    msg_1: "คุณแน่ใจไหมที่จะลบส่วนผสมนี้?",
    msg_2: "คุณแน่ใจไหมที่จะลบส่วนผสมทั้งหมด?",
    msg_3: "คุณต้องการเพิ่มส่วนผสมนี้หรือไม่?",
    msg_4: "คุณต้องการเพิ่มส่วนผสมที่ขาดหายไปทั้งหมดหรือไม่?",
    msg_5: "คุณต้องการเพิ่มส่วนผสมที่เลือกลงในตะกร้าสินค้าของคุณหรือไม่?",
    msg_6: "ส่วนผสมนี้มีอยู่ในตะกร้าสินค้าของคุณแล้ว.",
    confirm: "ใช่",
    cancel: "ไม่",
  },
  recipe_exist_in_cart: "ส่วนผสมนี้มีอยู่ในตะกร้าสินค้าของคุณแล้ว.",
  recipe_want_add_to_cart: "คุณต้องการเพิ่มส่วนผสมที่เลือกลงในตะกร้าสินค้าของคุณหรือไม่?",
  recipe_exist_in_cart_should_exclued: "มีอยู่ในรถเข็นปัจจุบันแล้ว จึงถูกยกเว้น",
  calories_description: "จานนี้คาดว่าจะให้พลังงานประมาณ {calories} แคลอรี ตามสูตรด้านล่าง โปรดพิจารณาเลือกสิ่งที่เหมาะสมสำหรับสุขภาพของคุณ!",
  title_share_sns: "แชร์สูตรนี้บน",
  copy: "คัดลอก",
  recipe_add_cart_success: "เพิ่มลงในตะกร้าแล้ว คุณต้องการไปที่หน้าตะกร้าหรือไม่?",
  recipe_close: "ปิด",
  recipe_move: "ย้าย",
  recipe_add_ingredient_success: "เพิ่มวัตถุดิบที่เลือกเรียบร้อยแล้ว คุณต้องการไปที่หน้าวัตถุดิบหรือไม่?",
  copied: "คัดลอกแล้ว",
  text_share_sns: `{recipe_name} สูตรนี้เป็นยังไง? ลองดูได้ที่ Hey! Cooker!`,
  search: {
    title: "ค้นหาสูตรอาหาร",
    searching: "Hey Cooker กำลังค้นหาสูตรอาหารที่ตรงกับ<br/>คำค้นหาของคุณ กรุณารอสักครู่!",
    not_found: "อืม เชฟ AI ไม่พบเมนูที่ตรงกับคำค้นหาของคุณ<br/>กรุณาลองใส่ชื่อเมนูอื่นดูนะ",
    placeholder: "ป้อนชื่อสูตรอาหารที่คุณต้องการค้นหา...",
    msg_default_recipe: "คุณยังไม่มีสูตรอาหาร",
  },
  noData: "ไม่พบผลลัพธ์",
  searching: "กำลังค้นหา..."
}
